import { ArrowLeft } from 'lucide-react';
import { Sheet, SheetContent, SheetTitle } from '@/shared/widgets/sheet';
import { BS_PROMISE_DETAIL_ITEMS } from '../data/bsPromises.data';
import { BsPromiseIcon } from './BsPromiseIcon';

interface BsPromisesSheetProps {
  open: boolean;
  onClose: () => void;
}

export function BsPromisesSheet({ open, onClose }: BsPromisesSheetProps) {
  return (
    <Sheet open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onClose(); }}>
      <SheetContent
        side="bottom"
        showCloseButton={false}
        className="left-0 right-0 bottom-0 flex h-[100dvh] max-h-[100dvh] flex-col rounded-none p-0"
      >
        <div className="flex shrink-0 items-center border-b border-[#e2e2e2] bg-white px-1 py-3 shadow-[0_1px_5px_0_#e2e2e2]">
          <button
            type="button"
            aria-label="Close BlueStone Promise details"
            className="p-3 text-[var(--link-blue)]"
            onClick={onClose}
          >
            <ArrowLeft className="h-[22px] w-[22px]" />
          </button>
          <SheetTitle className="text-[18px] font-semibold leading-none text-black">
            BlueStone Promise
          </SheetTitle>
        </div>

        <div className="flex-1 overflow-y-auto bg-[#f5f5f5] p-2.5">
          <div className="space-y-2.5">
            {BS_PROMISE_DETAIL_ITEMS.map((item) => (
              <article
                key={item.id}
                className="rounded-lg bg-white px-[15px] py-[15px] text-center shadow-[0_1px_4px_rgba(0,0,0,0.06)]"
              >
                <div className="mb-4 flex justify-center">
                  <BsPromiseIcon iconId={item.id} variant="detail" />
                </div>

                <strong className="block text-[16px] font-semibold uppercase leading-snug text-black">
                  {item.title}
                  {item.subtitle ? (
                    <>
                      <br />
                      <span className="text-[14px] font-semibold normal-case tracking-[0.015em]">
                        {item.subtitle}
                      </span>
                    </>
                  ) : null}
                </strong>

                <div className="mt-3 space-y-3 text-left text-[13px] leading-relaxed text-[#333]">
                  {item.paragraphs?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}

                  {item.listItems ? (
                    <ul className="list-disc space-y-1 pl-5">
                      {item.listItems.map((listItem) => (
                        <li key={listItem}>{listItem}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              </article>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
